import { render, staticRenderFns } from "./ComponentAuditList.vue?vue&type=template&id=fc58c3a8&scoped=true&"
import script from "./ComponentAuditList.vue?vue&type=script&lang=js&"
export * from "./ComponentAuditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc58c3a8",
  null
  
)

export default component.exports